<template>
    <div class="min-h-screen flex flex-col">
      <TopHeader class="max-lg:hidden" />
      <div class="container">
        <PublicationHeader class="max-lg:mt-5" />
        <main class="flex-auto max-md:px-3.75">
          <router-view />
        </main>
        <PublicationNav></PublicationNav>
      </div>
      <TheFooter></TheFooter>
    </div>
	<PageUpButton />
    
  </template>
  
  <script>

  import TopHeader from "@/components/TopHeader.vue";
  import PublicationNav from "@/components/publication/PublicationNav.vue";
  import TheFooter from "@/components/TheFooter.vue";
  import PublicationHeader from "@/components/publication/PublicationHeader.vue";
  import { updateLastSeen } from "@/helpers";
  import PageUpButton from '@/components/PageUpButton.vue'
  
  export default {
    name: "PublicationLayout",
    components: {
      TopHeader,
      PublicationHeader,
      TheFooter,
      PublicationNav,
      PageUpButton
    },
    data() {
      return {
        loading: false,
      };
    },
    methods: {
     
    },

    async mounted() {
      updateLastSeen("publications");
    },
  };
  </script>
  